import { formatDate } from '@/utils'

export default {
  computed: {
    v() {
      if(this.$v) {
        return this.$v;
      }
      return this.v$;
    },
    firstNameError() {
      if (this.v.firstName.required === false) {
        return 'required'
      } else if (this.v.firstName.maxLength === false) {
        return 'character limit exceeded'
      } else if (this.v.firstName.nameAlphaNumeric === false) {
        return 'only letters, spaces, *, -, and upto 4 digits allowed'
      }
    },
    middleInitialError() {
      if (this.v.middleInitial.maxLength === false) {
        return 'character limit exceeded'
      }
    },
    lastNameError() {
      if (this.v.lastName.required === false) {
        return 'required'
      } else if (this.v.lastName.maxLength === false) {
        return 'character limit exceeded'
      } else if (this.v.lastName.nameAlphaNumeric === false) {
        return 'only letters, spaces, numbers, *, and - allowed'
      }
    },
    suffixError() {
      if (this.v.suffix.maxLength === false) {
        return 'character limit exceeded'
      }
    },
    dobError() {
      if (this.v.dob.required === false) {
        return 'required'
      }
    },
    genderError() {
      if (this.v.gender.required === false) {
        return 'required'
      }
    },
    fileBoundIdError() {
      if (this.v.fileBoundId.required === false) {
        return 'required'
      } else if (this.v.fileBoundId.maxLength === false) {
        return 'character limit exceeded'
      } else if (this.v.fileBoundId.alphaNum === false) {
        return 'alphanumeric characters only'
      } else if (this.v.fileBoundId.fileBoundIdValidation === false) {
        return 'alphanumeric or | character only'
      }
    },
    clientIdError() {
      if (this.v.clientId.required === false) {
        return 'required'
      } else if (this.v.clientId.maxLength === false) {
        return 'character limit exceeded'
      } else if (this.v.clientId.alphaNum === false) {
        return 'alphanumeric characters only'
      }
    },
    eyemedIdError() {
      if (this.v.eyemedId.required === false) {
        return 'required'
      }
    },
    effectiveDateError() {
      if (this.v.effectiveDate.required === false) {
        return 'required'
      }

      if (this.v.effectiveDate.onOrAfterDOB === false) {
        return 'must be on or after date of birth'
      }

      if (this.v.effectiveDate.onOrAfterSubGroupEffectiveDate === false) {
        return 'must be on or after subgroup effective date of ' + formatDate(this.subGroupEffectiveDate)
      }

      if (this.v.effectiveDate.onOrAfterGroupEffectiveDate === false) {
        return 'must be on or after group effective date of ' + formatDate(this.groupEffectiveDate)
      }

      if (this.v.effectiveDate.onOrBeforeSubGroupTermDate === false) {
        return 'must be on or before subgroup term date of ' + formatDate(this.subGroupTermDate)
      }

      if (this.v.effectiveDate.onOrBeforeClassTermDate === false) {
        return 'must be on or before class term date of ' + formatDate(this.classTermDate)
      }

      if (this.v.effectiveDate.onOrBeforePlanTermDate === false) {
        return 'must be on or before plan term date of ' + formatDate(this.planTermDate)
      }

      if (this.v.effectiveDate.onOrBeforeGroupTermDate === false) {
        return 'must be on or before group term date of ' + formatDate(this.groupTermDate)
      }

      if (this.v.effectiveDate.onOrAfterClassEffectiveDate === false) {
        return 'must be on or after class effective date of ' + formatDate(this.classEffectiveDate)
      }

      if (this.v.effectiveDate.onOrAfterPlanEffectiveDate === false) {
        return 'must be on or after plan effective date of ' + formatDate(this.planEffectiveDate)
      }

      if (this.v.effectiveDate.afterOriginalEffectiveDateOfPrimarySubscriber === false) {
        return 'must be on or after original effective date of subscriber'
      }
    },
    termDateError() {
      if (this.v.termDate.afterEffectiveDate === false) {
        return 'must be after effective date of ' + formatDate(this.effectiveDate)
      }

      if (this.v.termDate.onOrBeforeSubGroupTermDate === false) {
        return 'must be on or before subgroup term date of ' + formatDate(this.subGroupTermDate)
      }

      if (this.v.termDate.onOrBeforeGroupTermDate === false) {
        return 'must be on or before group term date of ' + formatDate(this.groupTermDate)
      }

      if (this.v.termDate.onOrBeforeClassTermDate === false) {
        return 'must be on or before class term date of ' + formatDate(this.classTermDate)
      }

      if (this.v.termDate.onOrBeforePlanTermDate === false) {
        return 'must be on or before plan term date of ' + formatDate(this.planTermDate)
      }

      if (this.v.termDate.beforeTermDateOfPrimarySubscriber === false) {
        return 'must be before term date of subscriber'
      }
    },
    relationshipError() {
      if (this.v.relationship.required === false) {
        return 'required'
      }
    },
    planIdError() {
      if (this.v.planId.required === false) {
        return 'required'
      }
    },
    classIdError() {
      if (this.v.classId.required === false) {
        return 'required'
      }
    },
    groupCkError() {
      if (this.v.groupCk.required === false) {
        return 'required'
      }
    },
    parentGroupCkError() {
      if (this.v.parentGroupCk.required === false) {
        return 'required'
      }
    },
    subGroupCkError() {
      if (this.v.subGroupCk.required === false) {
        return 'required'
      }
    },
    zipError() {
      if (this.v.zip.required === false) {
        return 'required'
      } else if (this.v.zip.numeric === false) {
        return 'must be numeric'
      } else if (this.v.zip.fiveOrNineDigitsLong === false) {
        return '5 or 9 digits long'
      }
    },
    ssnError() {
      if (this.v.ssn.$model && this.v.ssn.$model.length > 0) {
        if (
          this.v.ssn.fourOrNineDigitsLong === false &&
          this.v.ssn.$dirty
        ) {
          return '4 or 9 digits long'
        }
      }
    },
    cityError() {
      if (this.v.city.required === false) {
        return 'required'
      }
      if (this.v.city.maxLength === false) {
        return 'character limit exceeded'
      }
    },
    stateError() {
      if (this.v.state.required === false) {
        return 'required'
      }
    },
    benefitOptionError() {
      if (this.v.benefitOption.required === false) {
        return 'required'
      }
      if (this.v.benefitOption.maxLength === false) {
        return 'character limit exceeded'
      }
    },
    locationCodeError() {
      if (this.v.locationCode.required === false) {
        return 'required'
      }
      if (this.v.locationCode.maxLength === false) {
        return 'character limit exceeded'
      }
    },
    companyCodeError() {
      if (this.v.companyCode.required === false) {
        return 'required'
      }
      if (this.v.companyCode.maxLength === false) {
        return 'character limit exceeded'
      }
    },
    divisionCodeError() {
      if (this.v.divisionCode.required === false) {
        return 'required'
      }
      if (this.v.divisionCode.maxLength === false) {
        return 'character limit exceeded'
      }
    }
  }
}
